// extracted by mini-css-extract-plugin
module.exports = {"module":"ProductImage_module__2Wnrk"};